module.exports = __webpack_public_path__ + "img/ComoLlegar.780abd36.svg";